'use strict';

var toastMessageHelper = require('../../utils/toastMessageHelper');
var earPiercingUtils = require('../../utils/dataAndSlots');
var errorMessage = $('#errormessage').val();
var selectStoreMessage = $('#selectStoreMessage').val();

// Initialize datepicker on page load
$(document).ready(function () {
    earPiercingUtils.initializeEarPiercingDatepicker();
    // Load time slots if store is already selected (coming back from form page)
    var selectedStore = $('#earpiercing-storepage .storedata .store-container.checked input[type="radio"]').val();
    if (selectedStore) {
        earPiercingUtils.loadSlots(selectedStore);
    }
});

$(document).on('click', '#earpiercing-storepage .storedata .store-container', function () {
    $('#earpiercing-storepage .storedata .store-container').removeClass('checked');
    $(this).addClass('checked');
});

$('body').on('click', '.piercingNext-btn', function (e) {
    e.preventDefault();
    var selectedStore = $('#earpiercing-storepage .storedata .store-container.checked input[type="radio"]').val();
    var piercingDate = $('#ckc-earpiercing-appointment-date').val().trim();
    var piercingTime = $('#earpiercingtimeslot .piercing-selected-value').text().trim().toLowerCase();
    var $selectedLabel = $('label[for="storedata-' + selectedStore + '"]');
    var storeName = $selectedLabel.find('.store-name').text().trim();
    var storeAddress = $selectedLabel.find('.store-address').text().trim();
    $('#piercingDate').val(piercingDate);
    $('#piercingTime').val(piercingTime);
    $('#selectedStore').val(selectedStore);
    $('#selectedStoreName').val(storeName);
    $('#selectedStoreAddress').val(storeAddress);
    var isValid = true;

    if (!selectedStore) {
        toastMessageHelper.showNotification(selectStoreMessage);
        isValid = false;
    }

    if (piercingDate === '') {
        $('.piercing-date-picker').removeClass('d-none');
        isValid = false;
    }

    if (piercingTime === 'select your slot') {
        $('.piercing-slots').removeClass('d-none');
        $('.noslots-available').addClass('d-none');
        isValid = false;
    }

    var $datePickerWrapper = $('.date-picker-input');
    var $slotdiv = $('.slot-dropdown-section');
    var $dateError = $('.piercing-date-picker');
    var $slotError = $('.piercing-slots');
    if (!$slotError.hasClass('d-none')) {
        $slotdiv.addClass('is-invalid');
    } else {
        $slotdiv.removeClass('is-invalid');
    }

    if (!$dateError.hasClass('d-none')) {
        $datePickerWrapper.addClass('is-invalid');
    } else {
        $datePickerWrapper.removeClass('is-invalid');
    }

    if (!isValid) {
        return;
    }
    $.spinner().start();
    var url = $('.piercingNext-btn').data('url');
    $.ajax({
        url: url,
        type: 'GET',
        data: {
            storeID: selectedStore
        },
        success: function (response) {
            $('#earpiercing-storepage').addClass('d-none');
            $('#earpiercing-formdata').removeClass('d-none');
            $('#earpiercing-formdata').html(response);
            $.spinner().stop();
            $('html, body').animate({
                scrollTop: $('#earpiercing-formdata').offset().top
            }, 500);
            $('#earpiercing-formdata').scrollTop(0);
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification(errorMessage);
        }
    });
});

$(document).on('click', '.piercing-time-slots li', function () {
    $('.piercing-slots').addClass('d-none');
    $('#slot-dropdown-section').removeClass('is-invalid');
});

$(document).on('change', '#ckc-earpiercing-appointment-date', function () {
    $('.piercing-date-picker').addClass('d-none');
    $('.date-picker-input').removeClass('is-invalid');
});

$('body').on('click', '#earpiercing-formdata .country-code .custom-option-value', function () {
    var $this = $(this);
    var countryCode = $this.data('id');
    var phoneLength = $this.data('phonelength');
    var $phoneInput = $('#earpiercing-formdata .phone-input');
    $phoneInput.attr('data-countrycode', countryCode);
    $this.closest('.custom-drop-down-section').find('.selected-value').text(countryCode);
    $this.siblings().removeClass('selected');
    $this.addClass('selected');
    if (phoneLength) {
        $phoneInput.attr('maxlength', phoneLength);
    }
    $phoneInput.val('');
    $phoneInput.removeClass('is-invalid');
    $phoneInput.siblings('.invalid-feedback').text('').hide();
});

$('body').on('click', '.form-firstname-dropdown .custom-option-value', function () {
    var $this = $(this);
    var titleCode = $this.data('title');
    var titleText = $this.text().trim();
    $this.siblings().removeClass('selected');
    $this.addClass('selected');
    $this.closest('.custom-drop-down-section').find('.selected-value').text(titleText);
    $('#catalogueTitle').val(titleCode);
});

$('body').on('click', '#earpiercing-storepage .time-slot-session .time-slot-value', function () {
    var $this = $(this);
    var $selected = $this.closest('.time-slot-select').find('.custom-drop-down-section .selected-value');
    if ($selected.length) {
        $selected.addClass('timeslot-selected-value');
    }
});

/**
 * Validates a guest checkout field using contextual rules (name, email, phone, or generic required checks).
 * @param {JQuery} $field - The input/select element wrapped in jQuery whose value should be validated.
 * @returns {boolean} True when the field value complies with its rules; otherwise false with feedback applied.
 */
function validateField($field) {
    var value = $field.val();
    var isValid = true;
    var errorMsg = '';
    var $errorDiv;
    var fieldId = $field.attr('id');
    var isNameField = fieldId === 'firstName' || fieldId === 'lastName';
    var isEmailField = $field.attr('type') === 'email';
    var isPhoneField = $field.attr('type') === 'tel' || fieldId === 'phone';
    var isageField = fieldId === 'month' || fieldId === 'ageofbirth';

    if ($field.attr('type') === 'checkbox') {
        if ($field.attr('id') === 'termsAccepted') {
            $errorDiv = $field.closest('.form-check').find('.invalid-feedback');

            if (!$field.is(':checked')) {
                $field.addClass('is-invalid');
                $errorDiv.text($field.data('missing-error')).show();
                return false;
            }
            $field.removeClass('is-invalid');
            $errorDiv.text('').hide();
            return true;
        }
        return true;
    }

    if (isNameField) {
        let cleanedValue = value.replace(/[^A-Za-z\s]/g, '').replace(/^\s+/, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value.trim()) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var pattern = /^[A-Za-z][A-Za-z\s]*$/;
        if (isValid && value && !pattern.test(value)) {
            isValid = false;
            errorMsg = $field.data('invalid-error');
        }
    } else if (isEmailField) {
        let cleanedValue = value.replace(/[^A-Za-z0-9@._-]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue.trim();

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var emailPattern = /^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (isValid && value && !emailPattern.test(value)) {
            isValid = false;
            errorMsg = $field.data('pattern-mismatch');
        }
    } else if (isPhoneField) {
        let cleanedValue = value.replace(/[^0-9]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);
        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var requiredLength = parseInt($field.attr('data-phonelength'), 10)
            || parseInt($field.attr('maxlength'), 10)
            || 10;

        var countryCode = $field.attr('data-countrycode');

        if (countryCode === '+91' && value.length > 0) {
            if (!/^[6-9]/.test(value)) {
                $field.val('');
                value = '';
                isValid = false;
                errorMsg = $field.data('format-error');
            }
        }

        if (isValid && value.length !== requiredLength) {
            isValid = false;
            errorMsg = 'Please enter valid phone number';
        }
    } else if (isageField) {
        let cleanedValue = value.replace(/[^0-9]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value.trim()) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        if (isValid && value) {
            if (fieldId === 'ageofbirth') {
                var ageRegex = /^(0|[1-9]\d?|1[0-4]\d|150)$/;
                if (!ageRegex.test(value)) {
                    isValid = false;
                    errorMsg = $field.data('invalid-error');
                }
            } else if (fieldId === 'month') {
                var monthRegex = /^(?:[1-9]|1[01])$/;
                if (!monthRegex.test(value)) {
                    isValid = false;
                    errorMsg = $field.data('invalid-error');
                }
            }
        }

        $field.on('input', function () {
            value = this.value;
            value = value.replace(/\D/g, '');

            let regex = null;

            if (fieldId === 'ageofbirth') {
                regex = /^(0|[1-9]\d?|1[0-4]\d|150)$/;
            } else if (fieldId === 'month') {
                regex = /^(?:[1-9]|1[01])$/;
            }

            if (regex && value !== '' && !regex.test(value)) {
                value = value.slice(0, -1);
            }

            this.value = value;
        });
    } else {
        value = value.trim();
        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }
    }

    $errorDiv = $field.siblings('.invalid-feedback');

    if (!isValid) {
        $field.addClass('is-invalid');
        $errorDiv.text(errorMsg);
    } else {
        $field.removeClass('is-invalid');
        $errorDiv.text('').hide();
    }

    return isValid;
}

$('body').on('change input blur', '#earpiercing-formdata input', function () {
    validateField($(this));
    if ($(this).hasClass('firstname-input')) {
        var $customDropdown = $('.firstname-input-field').find('.custom-drop-down');
        if ($(this).hasClass('is-invalid')) {
            $customDropdown.addClass('error-valid');
        } else {
            $customDropdown.removeClass('error-valid');
        }
    }
    if ($(this).hasClass('phone-input')) {
        var $phoneDropdown = $('.phone-input-field').find('.country-code-text');
        if ($(this).hasClass('is-invalid')) {
            $phoneDropdown.addClass('error-valid');
        } else {
            $phoneDropdown.removeClass('error-valid');
        }
    }
});

$('body').on('click', '#piercingformdetailsbtn', function (e) {
    e.preventDefault();
    var isFormValid = true;
    $('#earpiercing-formdata').find('input').each(function () {
        if (!validateField($(this))) {
            isFormValid = false;
        }
    });

    if ($('.piercing-type-dropdown .selected-value').hasClass('appointment-dropdown-placeholder')) {
        var errorMsg = $('.piercing-type-input').attr('data-missing-error');
        $('.piercing-type-dropdown').addClass('is-invalid');
        $('.piercing-type-dropdown').siblings('.invalid-feedback').text(errorMsg).show();
        isFormValid = false;
    }

    if (!isFormValid) {
        return;
    }

    var formData = {
        firstName: $('#firstName').val(),
        lastName: $('#lastName').val(),
        ageofbirth: $('#ageofbirth').val(),
        month: $('#month').val(),
        Piercingtype: $('.salutation-dropdown .selected-value').text(),
        email: $('#email').val(),
        phone: $('#phone').val(),
        Experience: $('#Experience').val(),
        selectedStore: $('#selectedStore').val(),
        selectedStoreName: $('#selectedStoreName').val(),
        selectedStoreAddress: $('#selectedStoreAddress').val(),
        piercingDate: $('#piercingDate').val(),
        piercingTime: $('#piercingTime').val(),
        salutation: $('#catalogueTitle').val(),
        countryCode: $('#earpiercing-formdata .country-code-text').text().trim(),
        termandconditionAccepted: $('#termsAccepted').is(':checked')
    };

    var submitUrl = $(this).data('submit-url');
    $.spinner().start();
    $.ajax({
        url: submitUrl,
        type: 'POST',
        data: formData,
        success: function (response) {
            if (response) {
                $('#appointmentID').val(response.appointmentID);
                $.ajax({
                    url: response.piercingURL,
                    type: 'GET',
                    success: function (priceResponse) {
                        $('#earpiercing-formdata').addClass('d-none');
                        $('#piercingpricepage').removeClass('d-none').html(priceResponse);
                        $.spinner().stop();
                        $('html, body').animate({
                            scrollTop: $('#piercingpricepage').offset().top
                        }, 500);
                        $('#piercingpricepage').scrollTop(0);
                    },
                    error: function () {
                        $.spinner().stop();
                        toastMessageHelper.showNotification(errorMessage);
                    }
                });
            }
        },
        error: function () {
            toastMessageHelper.showNotification(errorMessage);
        }
    });
});

/**
 * Resets the time slot selection to its default state.
 * Updates the text of the selected time slot element to show the alternative text
 * (either from data-alttext attribute or defaults to 'Choose...').
 *
 * @function resetTimeSlot
 * @returns {void}
 */
function resetTimeSlot() {
    var $sel = $('.piercing-selected-value');
    var altText = $sel.attr('data-alttext') || $sel.data('alttext') || 'Choose...';
    $sel.text(altText);
}

$('body').on('change', '#earpiercing-storepage input[name="storeOption"]', function () {
    var storeId = $(this).val();
    earPiercingUtils.loadSlots(storeId);
    resetTimeSlot();

    // Refresh datepicker to apply new store holidays
    var $dateInput = $('#ckc-earpiercing-appointment-date');
    if ($dateInput.length && $dateInput.data('datepicker')) {
        $dateInput.datepicker('setDate', null);
        $dateInput.val('');
        earPiercingUtils.initializeEarPiercingDatepicker();
    }

    // Show placeholder/alt text for the slot label
    var $tasSelectedValue = $('.piercing-selected-value');
    if ($tasSelectedValue.length) {
        var altText = $tasSelectedValue.attr('data-alttext') || $tasSelectedValue.data('alttext');
        $tasSelectedValue.text(altText || '').removeClass('timeslot-selected-value');
    }
});

$('body').on('click', '#earpiercingtimeslot', function () {
    var $this = $(this);
    if ($this.data('requesting') === true) {
        return;
    }
    var selectedDate = $('#ckc-earpiercing-appointment-date').val().trim();
    if (!selectedDate) {
        return;
    }
    var storeID = $('#earpiercing-storepage .storedata .store-container.checked input[type="radio"]').val();
    var url = $(this).data('url');
    var selectedslot = $('.piercing-selected-value').attr('data-slot');
    var customerPhone = $('.customerPhone').val();
    var customerEmail = $('.customerEmail').val();
    var tryatshowroomData = {
        storeID: storeID,
        customerPhone: customerPhone,
        customerEmail: customerEmail,
        selectedDate: selectedDate,
        tasSelectedValue: selectedslot
    };
    $this.data('requesting', true);
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'POST',
        data: tryatshowroomData,
        success: function (data) {
            $('#earpiercingSlots').html('');
            if (data.success === false) {
                $('.noslots-available').removeClass('d-none');
                $('.piercing-slots, .pickup-slot-scroll.scroll-bar').addClass('d-none');
                $.spinner().stop();
                $this.data('requesting', false);
                return;
            }
            $('.pickup-slot-scroll.scroll-bar').removeClass('d-none');
            $('#earpiercingSlots').html(data);
            $('.pickup-slot-scroll').scrollTop(0);
            $.spinner().stop();
            $this.data('requesting', false);
        },
        error: function () {
            $.spinner().stop();
            $this.data('requesting', false);
        }
    });
});

$('body').on('click', '#earpiercingtimeslot .time-slot-value', function () {
    if ($(this).hasClass('strick-out')) return;
    var selectedSlot = $(this).data('id');
    $('#earpiercingSlots').val(selectedSlot);
    $('.piercing-selected-value').attr('data-slot', selectedSlot);
});

$('body').on('click', '.comfirm-piercing-proceed', function () {
    var appointmentID = $('#appointmentID').val();
    var $form = $('.piercing-detailsoption');
    var dataUrl = $(this).data('url');
    var whatsappOption = $form.find('#whatsappoption').is(':checked');
    var textmessage = $form.find('#textoption').is(':checked');
    var emailOption = $form.find('label[for="emailoption"]').hasClass('checked');
    $.spinner().start();
    $.ajax({
        url: dataUrl,
        type: 'get',
        data: {
            appointmentID: appointmentID,
            whatsappOption: whatsappOption,
            textmessage: textmessage,
            emailOption: emailOption
        },
        success: function (response) {
            if (response) {
                $('#piercingpricepage').addClass('d-none');
                $('#piercingcomfirmationpage').removeClass('d-none');
                $('#piercingcomfirmationpage').html(response);
                $.spinner().stop();
                $('html, body').animate({
                    scrollTop: $('#piercingcomfirmationpage').offset().top
                }, 500);
                $('#piercingcomfirmationpage').scrollTop(0);
            }
        },
        error: function () {
            $.spinner().stop();
            // toastMessageHelper.showNotification(errorMessage);
        }
    });
});

$('body').on('click', '#piercing-comfirmpayment', function (e) {
    e.preventDefault();
    var appointmentID = $('#appointmentID').val();
    var netAmount = $(this).data('netamount');
    var grossAmount = $(this).data('grossamount');
    var gstAmount = $(this).data('gstamount');
    var $form = $('.piercing-detailsoption');
    var whatsappOption = $form.find('#whatsappoption').is(':checked');
    var textmessage = $form.find('#textoption').is(':checked');
    var emailOption = $form.find('label[for="emailoption"]').hasClass('checked');
    var url = $(this).data('url');
    $.ajax({
        url: url,
        type: 'POST',
        data: {
            netAmount: netAmount,
            grossAmount: grossAmount,
            gstAmount: gstAmount,
            whatsappOption: whatsappOption,
            textmessage: textmessage,
            appointmentID: appointmentID,
            emailOption: emailOption
        },
        success: function (data) {
            $.spinner().stop();
            if (data && data.error) {
                return;
            }
            if (data && data.success) {
                $('body').trigger('checkout:razorpaycheckout');
            }
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification('Something went wrong', 'Please try again later');
        }
    });
});

$('body').on('click', '.gobackto-earPiercingStorepage', function (e) {
    e.preventDefault();
    $('#earpiercing-formdata').addClass('d-none');
    $('#earpiercing-storepage').removeClass('d-none');
    $('html, body').animate({
        scrollTop: $('#earpiercing-storepage').offset().top
    }, 500);
    $('#earpiercing-storepage').scrollTop(0);
});

/**
 * Updates the ear piercing slots based on selected date and store
 */
function updateEarPiercingSlots() {
    var selectedDate = $('#ckc-earpiercing-appointment-date').val().trim();
    var storeID = $('#earpiercing-storepage .storedata .store-container.checked input[type="radio"]').val();
    var url = $('#earpiercingtimeslot').data('url');
    var selectedslot = $('.piercing-selected-value').attr('data-slot');
    var customerPhone = $('.customerPhone').val();
    var customerEmail = $('.customerEmail').val();
    var tryatshowroomData = {
        storeID: storeID,
        customerPhone: customerPhone,
        customerEmail: customerEmail,
        selectedDate: selectedDate,
        tasSelectedValue: selectedslot || ''
    };
    $.ajax({
        url: url,
        method: 'POST',
        data: tryatshowroomData,
        success: function (data) {
            $('#earpiercingSlots').html('');
            if (data.success === false) {
                return;
            }
            $('#earpiercingSlots').html(data);
        }
    });
}

$('body').on('change', '#ckc-earpiercing-appointment-date', function () {
    $('.invalid-feedback .noslots-available').addClass('d-none');
    var $tasSelectedValue = $('.piercing-selected-value');
    if ($tasSelectedValue.length) {
        var altText = $tasSelectedValue.attr('data-alttext') || $tasSelectedValue.data('alttext');
        $tasSelectedValue.text(altText || '');
        $tasSelectedValue.removeClass('timeslot-selected-value');
        $('.session-time-slots .time-slot-value').removeClass('time-slot-value-highlight');
        $tasSelectedValue.attr('data-slot', '');
    }

    updateEarPiercingSlots();
});

$('body').on('click', '#ckc-earpiercing-appointment-date, .earpiercing-icon', function (e) {
    e.preventDefault();
    var $dateInput = $('#ckc-earpiercing-appointment-date');
    if (!$dateInput.data('datepicker')) {
        earPiercingUtils.initializeEarPiercingDatepicker();
    }
    $dateInput.datepicker('show');
});

$(document).on('click', '.earpiercingcancel-btn', function (e) {
    e.preventDefault();
    var cancelUrl = $('#cancelBookingUrl').val();
    var appointmentID = $('#appointmentID').val();

    if (!cancelUrl) {
        window.location.reload();
        return;
    }

    $.spinner().start();
    $.ajax({
        url: cancelUrl,
        method: 'POST',
        data: {
            appointmentID: appointmentID
        },
        success: function (response) {
            if (response && response.success) {
                window.location.reload();
                $.spinner().stop();
            } else {
                toastMessageHelper.showNotification('Failed to cancel booking', 'Error');
                $.spinner().stop();
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
});

$('body').on('click', '#piercingedit-btn', function (e) {
    e.preventDefault();
    $.spinner().start();
    $('#piercingpricepage').addClass('d-none');
    $('#earpiercing-formdata').removeClass('d-none');
    $('html, body').animate({
        scrollTop: $('#earpiercing-formdata').offset().top
    }, 500);
    $('#earpiercing-formdata').scrollTop(0);
    $.spinner().stop();
});

$('body').on('change input blur', '#ckc-earpiercing-appointment-date', function () {
    $('.invalid-feedback .noslots-available').addClass('d-none');
    var selectedDate = $(this).val();
    var $slotdropdown = $('#slot-dropdown-section .slot-dropdown');
    var $slotdiv = $('.time-slot-select .custom-drop-down-section');

    if (selectedDate) {
        $slotdropdown.removeClass('disabledstate');
        $slotdiv.removeClass('slot-dropdown-section');
    } else {
        $slotdropdown.addClass('disabledstate');
        $slotdiv.addClass('slot-dropdown-section');
    }
});

$('body').on('click', '#earpiercing-formdata .piercing-type-dropdown .custom-option-value', function () {
    $('.selected-value.piercing-selected-value').removeClass('appointment-dropdown-placeholder');
    $('.piercing-type-dropdown').removeClass('is-invalid');
    $('.piercing-type-dropdown').siblings('.invalid-feedback').text('').hide();
});

$(document).ready(function () {
    var url = new URL(window.location.href);
    var paramValue = url.searchParams.get('name');
    url.searchParams.delete('name');
    window.history.replaceState({}, document.title, url.toString());

    var earpiercingdata = $('#earPiercing-ComfirmationPage').attr('data-url');
    if (earpiercingdata) {
        $.spinner().start();
        $.ajax({
            url: earpiercingdata,
            type: 'GET',
            data: {
                name: paramValue
            },
            success: function (response) {
                $.spinner().stop();
                if (response.success === false) {
                    window.location.href = response.redirectUrl;
                } else {
                    $('#earPiercing-ComfirmationPage').html(response);
                }
            },
            error: function () {
                $.spinner().stop();
                toastMessageHelper.showNotification(errorMessage);
            }
        });
    }
});
